import { DownOutlined, PlusOutlined } from "@ant-design/icons"
import { Button, type ButtonProps, Dropdown } from "antd"
import React, { useState } from "react"

import { useAppSelector } from "../../../hooks/use-app-selector.ts"
import { CreateProjectWizard } from "../../Project/ProjectAddPage/wizard/CreateProjectWizard.tsx"
import ProjectsLeadApproval from "./ProjectsLeadApproval.tsx"

interface ProjectsLeadApprovalTriggerProps {
  onRefetchCallback: () => void
}

export function ProjectsLeadApprovalTrigger({
  onRefetchCallback
}: ProjectsLeadApprovalTriggerProps) {
  const canConvertLeadToProject = useAppSelector(
    (state) =>
      state?.auth?.userInfo?.permissions?.codes?.projects?.features
        ?.project_approval
  )

  const [openApprovalModal, setOpenApprovalModal] = useState(false)
  const [openWizard, setOpenWizard] = useState(false)

  const toggleOpenModal = () => setOpenApprovalModal(!openApprovalModal)

  const onCloseHandler = (refetch = false) => {
    if (refetch) onRefetchCallback()
    setOpenApprovalModal(false)
  }

  const onWizardClose = () => setOpenWizard(false)

  const buttonProps: ButtonProps = {
    onClick: () => setOpenWizard(true),
    type: "primary",
    className: "w-auto",
    icon: <PlusOutlined />
  }

  return (
    <>
      {canConvertLeadToProject ? (
        <Dropdown.Button
          {...buttonProps}
          icon={<DownOutlined />}
          menu={{
            items: [
              {
                key: "from_lead",
                icon: <PlusOutlined />,
                label: "Create from lead",
                onClick: toggleOpenModal
              }
            ]
          }}
        >
          <PlusOutlined /> New Project
        </Dropdown.Button>
      ) : (
        <Button {...buttonProps} icon={<PlusOutlined />}>
          New Project
        </Button>
      )}

      {/*@todo add lazy + suspense */}
      {openApprovalModal && <ProjectsLeadApproval onClose={onCloseHandler} />}
      {openWizard && <CreateProjectWizard onClose={onWizardClose} />}
    </>
  )
}
